import {
  Table,
  TableBody,
  TableHead,
  TableRow,
  useMediaQuery,
  useTheme,
  Box,
  Typography,
} from '@mui/material';
import {
  GeneralTableBox,
  HeadTableCell,
  RowTableCell,
  NoDataSkeleton,
  ActionIconButton,
} from '../../../common';

const LegalEntitiesDataTable = ({ data, isLoading, onEdit, onDelete, LoadingComponent }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  if (isMobile) {
    return (
      <GeneralTableBox>
        {isLoading ? (
          <LoadingComponent />
        ) : data && data.length > 0 ? (
          <Box sx={{ p: 2 }}>
            {data.map((legalEntity, index) => (
              <Box
                key={legalEntity.uuid || index}
                sx={{
                  border: '1px solid #e0e0e0',
                  borderRadius: '8px',
                  p: 2,
                  mb: 2,
                  backgroundColor: 'white',
                }}
              >
                <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 1, mb: 2 }}>
                  <Box>
                    <Typography variant="caption" color="text.secondary">
                      Empresa
                    </Typography>
                    <Typography variant="body2" fontWeight="medium">
                      {legalEntity.company}
                    </Typography>
                  </Box>
                  <Box>
                    <Typography variant="caption" color="text.secondary">
                      CUIT
                    </Typography>
                    <Typography variant="body2" fontWeight="medium">
                      {legalEntity.cuit}
                    </Typography>
                  </Box>
                  <Box>
                    <Typography variant="caption" color="text.secondary">
                      Razón Social
                    </Typography>
                    <Typography variant="body2" fontWeight="medium">
                      {legalEntity.legal_business_name}
                    </Typography>
                  </Box>
                  <Box>
                    <Typography variant="caption" color="text.secondary">
                      Entidad Intermedia
                    </Typography>
                    <Typography variant="body2" fontWeight="medium">
                      {legalEntity.is_intermediate_entity ? 'Sí' : 'No'}
                    </Typography>
                  </Box>
                </Box>
                <Box>
                  <Typography variant="caption" color="text.secondary">
                    Contacto
                  </Typography>
                  <Typography variant="body2" fontWeight="medium" sx={{ mb: 2 }}>
                    {legalEntity.contact_information || 'Sin contacto'}
                  </Typography>
                </Box>
                <Box sx={{ display: 'flex', gap: 1, justifyContent: 'center' }}>
                  <ActionIconButton variant="edit" onClick={() => onEdit(legalEntity)} />
                  <ActionIconButton variant="delete" onClick={() => onDelete(legalEntity)} />
                </Box>
              </Box>
            ))}
          </Box>
        ) : (
          <NoDataSkeleton colSpan={1} message="No se encontraron personas jurídicas" />
        )}
      </GeneralTableBox>
    );
  }

  return (
    <GeneralTableBox>
      <Table aria-label="legal entities table">
        <TableHead>
          <TableRow>
            <HeadTableCell wmd="15%" wxs="20%">
              Empresa
            </HeadTableCell>
            <HeadTableCell wmd="10%" wxs="15%">
              CUIT
            </HeadTableCell>
            <HeadTableCell wmd="15%" wxs="20%">
              Razón Social
            </HeadTableCell>
            <HeadTableCell wmd="5%" wxs="10%">
              Entidad Intermedia
            </HeadTableCell>
            <HeadTableCell wmd="5%" wxs="10%">
              Cuota Social
            </HeadTableCell>
            <HeadTableCell wmd="10%" wxs="15%">
              Contacto
            </HeadTableCell>
            <HeadTableCell wmd="15%" wxs="5%">
              Acciones
            </HeadTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {isLoading ? (
            <LoadingComponent />
          ) : data && data.length > 0 ? (
            data.map((legalEntity, index) => (
              <TableRow key={legalEntity.uuid || index}>
                <RowTableCell fontxs="12px" fontmd="14px">
                  {legalEntity.company}
                </RowTableCell>
                <RowTableCell fontxs="12px" fontmd="14px">
                  {legalEntity.cuit}
                </RowTableCell>
                <RowTableCell fontxs="12px" fontmd="14px">
                  {legalEntity.legal_business_name}
                </RowTableCell>
                <RowTableCell fontxs="12px" fontmd="14px" align="center">
                  {legalEntity.is_intermediate_entity === '1' ? 'Sí' : 'No'}
                </RowTableCell>
                <RowTableCell fontxs="12px" fontmd="14px">
                  {legalEntity.membership_fee}
                </RowTableCell>
                <RowTableCell fontxs="12px" fontmd="14px">
                  {legalEntity.contact_information || 'Sin contacto'}
                </RowTableCell>
                <RowTableCell sx={{ textAlign: 'center' }}>
                  <ActionIconButton variant="edit" onClick={() => onEdit(legalEntity)} />
                  <ActionIconButton variant="delete" onClick={() => onDelete(legalEntity)} />
                </RowTableCell>
              </TableRow>
            ))
          ) : (
            <NoDataSkeleton colSpan={7} message="No se encontraron personas jurídicas" />
          )}
        </TableBody>
      </Table>
    </GeneralTableBox>
  );
};

export default LegalEntitiesDataTable;
